import { jsx as _jsx } from "react/jsx-runtime";
import Responsive from "react-responsive";
// value         |0px     600px    960px    1280px   1920px
// key           |xs      sm       md       lg       xl
// screen width  |--------|--------|--------|--------|-------->
// range         |   xs   |   sm   |   md   |   lg   |   xl
//Mui v4 default breakpoints
export const MuiXS = 0;
export const MuiSM = 600;
export const MuiMD = 960;
export const MuiLG = 1280;
export const MuiXL = 1920;
export const Mobile = (props) => _jsx(Responsive, Object.assign({}, props, { maxWidth: MuiMD }));
export const Desktop = (props) => _jsx(Responsive, Object.assign({}, props, { minWidth: MuiMD }));
